import {
  FilterWidgetFormFieldPathType,
  IFilterWidgetState,
  IPredicateFormFieldPath,
} from '../types';
import { FieldPath } from 'react-hook-form';
import { UnreachableCaseError } from 'ts-essentials';

export const getPredicateFormFieldPath = (path: IPredicateFormFieldPath) => {
  if (path.type === FilterWidgetFormFieldPathType.SimplePredicate) {
    const { conditionIndex, predicateIndex } = path;
    return `conditions.${conditionIndex}.predicates.${predicateIndex}` as const satisfies FieldPath<IFilterWidgetState>;
  } else if (path.type === FilterWidgetFormFieldPathType.ArrayObjectPredicate) {
    const { conditionIndex, predicateIndex, predicateElementIndex } = path;
    // eslint-disable-next-line max-len
    return `conditions.${conditionIndex}.predicates.${predicateIndex}.predicateElements.${predicateElementIndex}` as const satisfies FieldPath<IFilterWidgetState>;
  } else {
    throw new UnreachableCaseError(path);
  }
};
